import { render, staticRenderFns } from "./DraggableEvent.vue?vue&type=template&id=36588c21&scoped=true"
import script from "./DraggableEvent.vue?vue&type=script&lang=js"
export * from "./DraggableEvent.vue?vue&type=script&lang=js"
import style0 from "./DraggableEvent.vue?vue&type=style&index=0&id=36588c21&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36588c21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36588c21')) {
      api.createRecord('36588c21', component.options)
    } else {
      api.reload('36588c21', component.options)
    }
    module.hot.accept("./DraggableEvent.vue?vue&type=template&id=36588c21&scoped=true", function () {
      api.rerender('36588c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/DraggableEvent.vue"
export default component.exports